module.exports = __webpack_public_path__ + "img/chat.269b735d.png";